import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../../public/static/icons/close-black.svg';

import styles from './index.module.scss';

const InfoMessage = ({ text, onClose }) => (
  <div className={styles['info-message']}>
    <div
      className={styles['info-message__text']}
      data-component="address-autocomplete-info-message"
    >
      {text}
    </div>
    <CloseIcon
      id="address-autocomplete-ie-info-message-close"
      className={styles['info-message__close-icon']}
      onKeyDown={(e) => e.key === 'Enter' && onClose()}
      onClick={onClose}
      tabIndex="0"
      data-component="address-autocomplete-info-message-close"
    />
  </div>
);

InfoMessage.propTypes = {
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default InfoMessage;
